import React,{Component} from "react";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory, Redirect } from "react-router-dom";
import "./Footer.css"
import contrary from "./Im/contrary.png"
import sandeep from './Im/sandeep.jpg';
import kunal from './Im/kunal.jpg';
import abdul from './Im/abdul.jpg';
import polygon from './Im/polygon.png';

var year = new Date().getFullYear();
//alert(year);

class Footer extends React.Component{

    render(){
        return(
            <footer>
                <div className="footer-container">
                    <div className="footer-widgets">
                        <div>
                            <h4>Diginoor</h4>
                            <ul>
                            <li className="ftr-li"><Link to ="/collections">Explore</Link></li>
                            <li className="ftr-li"> <Link to ="/how%20it%20works">Help Center</Link></li>
                            <li className="ftr-li">  <Link to ="/blog">Blog</Link></li>
                            <li className="ftr-li">  <a href="https://linktr.ee/diginoor.io" target="_blank">Jobs</a></li>
                            <li className="ftr-li">  <Link to ="/contact">Become a partner</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4>Community</h4>
                            <ul>
                            <li className="ftr-li"> <Link to ="/about">About</Link></li>
                            <li className="ftr-li"> <Link to ="/contact">Suggest feature</Link></li>
                            <li className="ftr-li"> <Link to ="/contact">Contact Us</Link></li>
                            <li className="ftr-li"> <Link to ="/how%20it%20works">FAQS</Link></li>
                            <li className="ftr-li"> <Link to ="/how%20it%20works">All about NFTs</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4>Backed By</h4>
                            <ul>
                              <li className="ftr-li"><div><img src={contrary} className="footer-in-ic"/><a href="https://contrarycap.com/">Contrary Capital</a></div></li> 
                              <li className="ftr-li"><div><img src={sandeep} className="footer-in-ic"/><a href="https://www.linkedin.com/in/sandeep-nailwal-60709a33/">Sandeep Nailwal</a></div></li>
                              <li className="ftr-li"><div><img src={polygon} className="footer-in-ic"/><a href="https://polygon.technology/">Polygon</a></div></li>
                              <li className="ftr-li"><div><img src={kunal} className="footer-in-ic"/><a href="https://www.linkedin.com/in/kunalshah1/">Kunal Shah</a></div></li>
                              <li className="ftr-li"><div><img src={abdul} className="footer-in-ic"/><a href="https://www.linkedin.com/in/abdul-wahab-al-halabi-97127a/">Abdul Wahab</a></div></li>
                            </ul>
                        </div>
                        <div>
                        <div>
                            <h4 className="subs-ftr">Subscribe to our Newsletter</h4>
                            </div>
                            <div>
                                <form className="fot-form">
                                    <input name="email" className="fot-input" type="text" placeholder="enter your mail id"></input><button className="fot-bt">I'm in</button>
                                    </form>
                                    </div>
                                    <div className="footer-social">
                                         <h4>  Join the Diginoor Community</h4>
                                         <a class="fb-ic social-md">
                                             <a href="https://www.facebook.com/diginoornft/" target="_blank"><i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                                             </a>
                                         <a class="tw-ic social-md">
                                             <a href="https://twitter.com/diginoor_NFT" target="_blank"><i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                                             </a>
                                         <a class="gplus-ic social-md">
                                             <a href="https://discord.gg/C2APxt2h4P" target="_blank"><i class="fab fa-discord fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                                             </a>
                                         <a class="li-ic social-md">
                                             <a href="https://www.linkedin.com/company/diginoor" target="_blank"> <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                                             </a>
                                         <a class="ins-ic social-md">
                                             <a href="https://www.instagram.com/diginoor.io" target="_blank"><i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a> 
                                             </a>
                                         <a class="pin-ic social-md">
                                             <a href="https://wa.me/+15714120310" target="_blank"> <i class="fab fa-whatsapp fa-lg mr-md-5 mr-3 white-text fa-2x"> </i></a>
                                             </a>
                                         <a class="pin-ic social-md">
                                             <a href="https://t.me/+LsXcY48EHCMwMGU1" target="_blank"> <i class="fab fa-telegram fa-lg mr-md-5 mr-3 white-text fa-2x"> </i></a>
                                             </a>
                                            </div>
                                         </div>
                    </div>
                    <div className="footer-cpyright">
                    <div className="footer-copyright text-left py-3">© {year} Copyright
                    <a href="#"> Diginoor Inc</a>
                    <a href="/Termscondition" className="terms-fot">Terms & Condition</a>
                    <a href="/Privacypolicy" className="terms-fot">Privacy Policy</a>
                    </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;